import React, { useEffect, useState } from "react";
import axios from "axios";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, ChartOptions } from "chart.js";
import { FaBoxOpen, FaShoppingCart, FaUsers } from "react-icons/fa";
import AspirasiBerandaSkeleton from "../../../../Components/loading/skeletonBeranda";

ChartJS.register(ArcElement, Tooltip, Legend);

const DashboardSummary = () => {
  const [summary, setSummary] = useState({
    total_products: 0,
    total_orders: 0,
    total_users: 0,
  });

  const [topProducts, setTopProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchSummary = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/summary`);

      setSummary(res.data.summary);
      setTopProducts(res.data.top_products || []);
    } catch (err) {
      console.error("Gagal fetch summary:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, []);

  if (loading) {
    return <AspirasiBerandaSkeleton />;
  }

  const noOrder = topProducts.length === 0;

  const chartData = {
    labels: noOrder ? ["Belum Ada Order"] : topProducts.map((p) => p.product_name),
    datasets: [
      {
        data: noOrder ? [1] : topProducts.map((p) => p.percentage),
        backgroundColor: noOrder ? ["#d1d5db"] : ["#4a1e94", "#22c55e", "#f0aa17"],
        hoverOffset: 6,
      },
    ],
  };

  const options: ChartOptions<"doughnut"> = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
    },
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* SUMMARY CARDS */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* TOTAL PRODUK */}
        <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
          <div className="bg-indigo-100 w-fit p-4 rounded-lg mb-3">
            <FaBoxOpen className="text-indigo-600 text-xl" />
          </div>

          <p className="text-gray-500 text-sm">Total Produk</p>
          <h2 className="text-4xl font-bold">{summary.total_products}</h2>
        </div>

        {/* TOTAL ORDER */}
        <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition">
          <div className="bg-green-100 w-fit p-4 rounded-lg mb-3">
            <FaShoppingCart className="text-green-600 text-xl" />
          </div>

          <p className="text-gray-500 text-sm">Total Order</p>
          <h2 className="text-4xl font-bold">{summary.total_orders}</h2>
        </div>

        {/* TOTAL USERS */}
        <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition md:col-span-2">
          <div className="bg-orange-100 w-fit p-4 rounded-lg mb-3">
            <FaUsers className="text-orange-600 text-xl" />
          </div>

          <p className="text-gray-500 text-sm">Total Users</p>
          <h2 className="text-4xl font-bold">{summary.total_users}</h2>
        </div>
      </div>

      {/* CHART */}
      <div className="bg-white p-6 rounded-lg shadow flex flex-col items-center">
        <h2 className="text-lg font-bold mb-4">Top Produk Terlaris</h2>

        <div className="w-full max-w-xs">
          <Doughnut data={chartData} options={options} />
        </div>

        {noOrder && <p className="text-gray-400 text-sm mt-3">Belum ada order masuk</p>}
      </div>
    </div>
  );
};

export default DashboardSummary;
